// Javascript main files
import './serverComs'
import './audioEngine'
import './sessionManager'
import './SamplePlayer'
import './MidiHandler' // has a side effect, calling the constructor and asking for midi input
import './3rd_party/gruf-pianoroll'


// CSS
import '../styles/index.scss'


// Instruments (per afegir noves instruments, s'ha d'exportar la classe des de ./instruments/index
import instruments from './instruments/index'
import {registerInstrumentDisponible} from './sessionManager'

instruments.forEach(instrument => registerInstrumentDisponible(instrument))